<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Slow Cooker Double Dinners for Two">
<div class="frontmatter">
<div class="recto">
<h1 class="title"><a id="index">Slow Cooker Double Dinners for Two</a></h1><a id="index">
<h2>Cook Once, Eat Twice!</h2>
<h3 class="author">Cynthia Graubart</h3>
<h4>Photographs by Rick McKee </h4>
<img alt="Gibbs Smith Logo" src="images/logo.jpg"/>
</a></div><a id="index">
<div class="verso">
<p class="versotitle">Slow Cooker Double Dinners for Two</p>
<p class="versotitle">Cook Once, Eat Twice!</p>
<p>Digital Edition 1.0</p>
<p class="copyright">Text © 2014 Cynthia Graubart</p>
<p>Photographs © 2014 by Rick McKee </p>
<p>All rights reserved. No part of this book may be reproduced by any means
                        whatsoever without written permission from the publisher, except brief
                        portions quoted for purpose of review.</p>
<p class="nobreak">Gibbs Smith</p>
<p class="nobreak">P.O. Box 667</p>
<p>Layton, Utah 84041</p>
<p class="nobreak">Orders: 1.800.835.4993</p>
<p>www.gibbs-smith.com</p>
<p>ISBN: 978-1-4236-3626-7</p>
</div>
</a></div><a id="index">
<div class="frontmatter">
<div class="acknowledgements" title="Acknowledgements">
<h3>Acknowledgments</h3>
<p>I owe a debt of gratitude to the incomparable Nathalie Dupree for her
                        friendship, mentorship, and most of all, the idea for this book! I’m still
                        loving our near thirty-year journey together and treasure your support. </p>
<p>My team is simply fabulous: photographer Rick McKee shot these taste-tempting
                        photos (with the patience of a saint); talented food stylist Nan McCullough
                        brought out the very best in my recipes (it’s our second book together);
                        Elise Garner is my right hand in times of crisis, exemplifying all you could
                        want in an assistant; and Rebecca Battle, who has the most gentle and
                        professional manner, was my double in thought, word, and deed when my
                        energies had to be focused elsewhere during shooting. </p>
<p>My publishing team at Gibbs Smith gives me plenty of reasons why producing a
                        book with a small publisher is such a pleasure. Deep thanks to my editor
                        extraordinaire, Madge Baird. Thanks also to all of those who perform duties
                        behind the scenes that when put together make a wonderful book that I’m
                        proud to put my name on. </p>
<p>My family has enjoyed this journey with me and provides such love and
                        support. Thank you to my husband, Cliff, and my children, Norman and
                        Rachel.</p>
</div>
</div>
</a></div><a id="index">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?17ff2cb9